import { Component } from '@angular/core';

@Component({
  selector: 'app-fine-taglist',
  imports: [],
  templateUrl: './fine-taglist.component.html',
  styleUrl: './fine-taglist.component.css'
})
export class FineTaglistComponent {

}
